import { adminMutation } from "@/admin/utils/adminMutation.ts";
import { queryKey } from "@/modules/location/locationQuery.ts";
import { jsonEncodedBody } from "@/utils/fetchClient.ts";
import type { LocationBody } from "@warrenio/api-spec/spec.oats.gen";

const entity = "Location";

export const locationCreateMutation = adminMutation((apiClient) => ({
    entity,
    operation: "create",
    requestFn: async ({ body, location }: { body: LocationBody; location: string }) =>
        await apiClient.PUT("/config/locations/{location}", {
            params: { path: { location } },
            ...jsonEncodedBody,
            body,
        }),
    invalidateQueryKey: queryKey,
}));

export const locationUpdateMutation = adminMutation((apiClient) => ({
    entity,
    operation: "update",
    requestFn: async ({ body, location }: { body: LocationBody; location: string }) =>
        await apiClient.PUT("/config/locations/{location}", {
            params: { path: { location } },
            ...jsonEncodedBody,
            body,
        }),
    invalidateQueryKey: queryKey,
}));

export const locationDeleteMutation = adminMutation((apiClient) => ({
    entity,
    operation: "delete",
    requestFn: async ({ location }: { location: string }) =>
        await apiClient.DELETE("/config/locations/{location}", {
            params: { path: { location } },
        }),
    invalidateQueryKey: queryKey,
}));
